import { createSlice } from '@reduxjs/toolkit';
import {
  AddLinkAction,
  DeletePromoLinkAction,
  SetFormFieldAction,
  SetIsLinksLoadingAction,
  SetLinksAction,
  StartEditAction,
  UpdateLinkAction,
  PromoLinksState,
} from '$store/promoLinks/interface';
import { RootState } from '$store/rootReducer';

const initialState: PromoLinksState = {
  links: [],
  isLinksLoading: false,
  editingId: null,
  form: {
    name: '',
    description: '',
    slug: '',
  },
};

export const { actions, reducer } = createSlice({
  name: 'promoLinks',
  initialState,
  reducers: {
    setIsLinksLoading(state, action: SetIsLinksLoadingAction) {
      state.isLinksLoading = action.payload;
    },
    setFormField(state, action: SetFormFieldAction) {
      state.form[action.payload.name] = action.payload.value;
    },
    clearForm(state) {
      state.form = initialState.form;
      state.editingId = null;
    },
    startEdit(state, action: StartEditAction) {
      state.editingId = action.payload.id;
      state.form = {
        name: action.payload.name,
        description: action.payload.description || '',
        slug: action.payload.slug,
      };
    },
    editPromoLink() {},
    updateLink(state, action: UpdateLinkAction) {
      state.links = state.links.map((link) =>
        link.id === action.payload.id ? action.payload : link,
      );
    },
    loadLinks() {},
    setLinks(state, action: SetLinksAction) {
      state.links = action.payload;
    },
    addLink(state, action: AddLinkAction) {
      state.links = [action.payload, ...state.links];
    },
    createPromoLink() {},
    removePromoLink(state, action: DeletePromoLinkAction) {
      state.links = state.links.filter((link) => link.id !== action.payload);
    },
    deletePromoLink(_, action: DeletePromoLinkAction) {},
  },
});

export const promoLinksSelector = (state: RootState) => state.promoLinks;
export const promoLinksFormSelector = (state: RootState) => state.promoLinks.form;

export { reducer as promoLinksReducer, actions as promoLinksActions };
